"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeLoopChecker = exports.makeTransition = exports.terminalOrSkip = exports.isTerminal = exports.negateNumberSymbol = exports.isBooleanSymbol = exports.negateBooleanSymbol = exports.isSymbol = exports.unusedSymbol = exports.terminateSymbol = exports.skipSymbol = exports.makeSequenceSymbol = exports.makeBranchSymbol = exports.makeFunctionSymbol = exports.makeInequalitySymbol = exports.makeLogicalSymbol = exports.makeLiteralValueSymbol = exports.makeNumberSymbol = void 0;
function makeNumberSymbol(name, constant, isPositive) {
    return {
        type: 'NumberSymbol',
        name,
        constant,
        isPositive: isPositive === undefined ? true : isPositive
    };
}
exports.makeNumberSymbol = makeNumberSymbol;
function makeLiteralValueSymbol(value) {
    return { type: 'LiteralValueSymbol', value };
}
exports.makeLiteralValueSymbol = makeLiteralValueSymbol;
function makeLogicalSymbol(left, right, conjunction) {
    return {
        type: 'LogicalSymbol',
        left,
        right,
        conjunction: conjunction === undefined ? true : conjunction
    };
}
exports.makeLogicalSymbol = makeLogicalSymbol;
function makeInequalitySymbol(name, constant, direction) {
    return { type: 'InequalitySymbol', name, constant, direction };
}
exports.makeInequalitySymbol = makeInequalitySymbol;
function makeFunctionSymbol(name, args, loc) {
    return { type: 'FunctionSymbol', name, args, loc };
}
exports.makeFunctionSymbol = makeFunctionSymbol;
function makeBranchSymbol(test, consequent, alternate) {
    return { type: 'BranchSymbol', test, consequent, alternate };
}
exports.makeBranchSymbol = makeBranchSymbol;
function makeSequenceSymbol(symbols) {
    return { type: 'SequenceSymbol', symbols };
}
exports.makeSequenceSymbol = makeSequenceSymbol;
exports.skipSymbol = { type: 'SkipSymbol' };
exports.terminateSymbol = { type: 'TerminateSymbol' };
exports.unusedSymbol = { type: 'UnusedSymbol' };
function isSymbol(node) {
    return node.type.slice(-6) === 'Symbol';
}
exports.isSymbol = isSymbol;
function negateBooleanSymbol(sym) {
    if (sym.type === 'LogicalSymbol') {
        const newLhs = negateBooleanSymbol(sym.left);
        const newRhs = negateBooleanSymbol(sym.right);
        return makeLogicalSymbol(newLhs, newRhs, !sym.conjunction); // de morgans
    }
    else if (sym.type === 'InequalitySymbol') {
        if (sym.direction === 0) {
            return makeLogicalSymbol(Object.assign(Object.assign({}, sym), { direction: 1 }), Object.assign(Object.assign({}, sym), { direction: -1 }), false);
        }
        else {
            const newConst = sym.constant + sym.direction;
            return makeInequalitySymbol(sym.name, newConst, -sym.direction);
        }
    }
    return sym;
}
exports.negateBooleanSymbol = negateBooleanSymbol;
function isBooleanSymbol(node) {
    return node.type === 'LogicalSymbol' || node.type === 'InequalitySymbol';
}
exports.isBooleanSymbol = isBooleanSymbol;
function negateNumberSymbol(sym) {
    return Object.assign(Object.assign({}, sym), { constant: -sym.constant, isPositive: !sym.isPositive });
}
exports.negateNumberSymbol = negateNumberSymbol;
function isTerminal(node) {
    if (node.type === 'BranchSymbol') {
        return isTerminal(node.consequent) && isTerminal(node.alternate);
    }
    else if (node.type === 'SequenceSymbol') {
        return node.symbols.every(isTerminal);
    }
    return node.type !== 'FunctionSymbol' && node.type !== 'SkipSymbol';
}
exports.isTerminal = isTerminal;
function terminalOrSkip(node) {
    return isTerminal(node) || node.type === 'SkipSymbol';
}
exports.terminalOrSkip = terminalOrSkip;
function makeTransition(caller, callee, condition) {
    return { caller, callee, condition };
}
exports.makeTransition = makeTransition;
function makeLoopChecker(functionName, message, condition, loc) {
    return {
        functionName,
        message: 'Infinite recursion (or runtime error) detected. ' + message,
        condition,
        loc
    };
}
exports.makeLoopChecker = makeLoopChecker;
//# sourceMappingURL=symTypes.js.map